const text = `LEGAL NOTICE OF THE SIDE ONCO SKIN® APPLICATION


PUBLISHER


PIERRE FABRE DERMO-COSMETICS, a simplified joint stock company (SAS) under French law having its head office at the following address: Les Cauquillous - 81500 Lavaur - France, registered with the Castres Trade and Companies Register under number 319 137 576.

FUNDING

PIERRE FABRE DERMO-COSMETICS, a simplified joint stock company (SAS) under French law having its head office at the following address: Les Cauquillous - 81500 Lavaur - France, registered with the Castres Trade and Companies Register under number 319 137 576.



Publishing Director


Mr. Frédéric Ennabli, CEO, Pierre Fabre Dermo-Cosmetics


Webmaster


contact.avene@pierre-fabre.com


Hosting Service Provider


OVH

Simplified joint-stock company (SAS) under French law with a capital of €10,069,020, registered with the Lille Trade and Companies Register

under number 537 407 926, having its head office at 2 rue Kellermann - 59100 Roubaix - France


Credits


Editorial/Photos: Dr. Caroline Robert, Dr. Emmanuelle Vigarios, Dr. Vincent Sibaud, Dr. Jean-Pierre Delord,

Technical design/production:

Henri Trip - 756 CHEMIN DE LA CRABO 31870 LAGARDELLE-SUR-LEZE (France) - SIRET no.: 88821442600015



GENERAL CONDITIONS OF USE FOR THE SIDE ONCO SKIN® APPLICATION

These general conditions of use (hereinafter the “GCU”) determine the terms and conditions for accessing and using the “ONCO SKIN®” mobile application belonging exclusively to (hereinafter the “Application”). The users (hereinafter the “Users”) accept the GCU solely by reason of consulting these GCU. The Application may be downloaded from: Apple Store, Google Play. If you do not accept them, please exit the Application. The GCU are subject to French law and may be modified at any time without prior notice. The use and consultation of the Application are restricted to personal, non-commercial purposes. In general, the User shall refrain from using all or part of the Application for illicit purposes (copyright) or purposes contrary to the GCU. By consulting this Application, the User agrees to abide by the GCU as published on the date of the consultation.


ARTICLE 1. PURPOSE OF THE APPLICATION:


The Application has been created to support and train health care professionals (general practitioners and specialists, pharmacists, paramedical staff, medical interns) in the management of patients suffering from dermatological conditions caused by cancer treatments through:

• the digitization of the book “Dermatologie des traitements anticancéreux” [Dermatology of cancer treatments] by Dr. Caroline Robert and Dr. Vincent Sibaud;

• quizzes and case studies for health care professionals.

(Hereinafter “Information”).

The Application does not constitute a contractual offer. The Application is free of charge and does not have in-app purchases.

The Application displays non-contractual information on dermatological pathologies in particular, with the ever-present desire to improve patient treatment by the health care professionals mentioned above, but with no intention of making a direct sales offer of products or services (unless explicitly indicated otherwise) linked to the pathologies.

Given that the updating of the Application is performed while taking into account all activities, certain new information or announcements may no longer be valid at the time they are published, or they may simply be outdated. PFDC cannot guarantee, despite making every possible effort, that the Information or news disseminated in the Application is completely up to date.

The Information provided on the Application aims to improve, and not to replace, the relationship existing between the health care professional and the patient.


ARTICLE 2. EDITORIAL POLICY:


The scientific content of the Application is partly written by doctors, experts in their field of dermatology:

•

• Dr. Vincent Sibaud


The content of the Application is updated every three (3) months.


ARTICLE 3. TECHNICAL CONFIGURATION REQUIRED


Pierre Fabre Dermo-Cosmetics (PFDC) reminds the Users that the use of the Application presupposes that the User has the necessary hardware and software capacities to use the Internet. In order to use the Application via a mobile phone (hereinafter “Equipment”), the User must have access to an appropriate high-speed Internet connection, a telephone subscription enabling Internet access, a mobile phone that is compatible with the Application such as a smartphone (IOS, Android), a WAP connection, Wi-Fi and/or 3G/4G on the telephone.


ARTICLE 4. CREATING AND DELETING A USER ACCOUNT


In order to obtain access to the Application, it is mandatory to register and to create a user account (hereinafter “User account”). As such, the User is requested to download the Application and to fill out the registration form (profession, contact details, email, password). All Users are only authorized to hold one (1) User Account. One (1) copy of the Application may be installed on their Equipment.


The User acknowledges that he/she is responsible for maintaining the confidentiality and personal nature of the username and password associated with his/her User Account. Consequently, the User agrees to be solely and exclusively responsible to PFDC for all actions carried out from his/her User Account and for protecting his/her password. The User’s password must be kept secure and must not be disclosed to or shared with third parties. Therefore, any connection or data transmission made with a User’s password will be deemed to have been made by the User. PFDC cannot be held responsible in any way for the loss of this password. In the event of loss or theft of his/her password and/or User Account, the User undertakes to inform PFDC without delay at the address given on the top of the CGU or by email to the following address: contact.avene@pierre-fabre.com.


Users may request the deletion of their User Account and any data concerning them, at any time, without having to provide any reason, simply by sending an email to the following address: contact-avene@pierre-fabre.com or a letter to the address on the top of the GCU.


Users may also delete their User Account directly in the application, in the “My Profile” section, at any time, without having to provide any reason. PFDC may terminate the use of the Application by a User subject to prior notice of one (1) month.


PFDC also reserves the right to terminate the User Account as of right, in the event of a binding legal ruling, force majeure events, breaches of these GCU, or suspicion of fraud.


PFDC reserves the right to seek compensation in reparation for damage suffered as a result of such breaches.


Termination of the User Account entails the termination of licenses granted to the User, who must cease all use of the Application. In this respect, the User will have no right to compensation.

PFDC may need to disclose personal information when required in order to identify, question or bring charges against any individual likely to intentionally or otherwise violate or infringe the rights or intellectual property of the Application, or harm other users of the Application or any other person as a result of such activities.


ARTICLE 5. CONDITIONS OF USE OF THE APPLICATION


The User recognizes that the conditions of the contract with his/her mobile telephone operator will continue to apply during the use of the Application. The User will assume sole responsibility for all costs that may be claimed by the mobile telephone operator relating to access to Internet connection services, Wi-Fi, WAP and/or 3G, on using the Application.


The User shall refrain, when using the Application, from impeding or disrupting the proper operation of the Application, servers and networks connected to the Application and/or modifying, adapting, pirating the Application and/or modifying an application or a third-party website in such a manner as to generate confusion regarding the link with the Application.

The User is aware of the constraints and limitations of mobile Internet networks and of telecommunication, and consequently undertakes:

• To protect their Hardware against all types of viruses and against any attempt at unauthorized intrusion, access, and/or use by third parties;

• To ensure that the installation, operation and maintenance conditions of his/her Equipment meet the requirements for the correct functioning of the Application.


ARTICLE 6. USAGE OF THE ADVICE PROVIDED IN THE APPLICATION


Information is made available to Users on the Application. This provision of information does not entail any transfer of property rights attached to said information. Users are only granted non-exclusive permission to view and use the information for their private usage. In this respect, the User is prohibited from copying or reproducing the information in full or in part, by any means and on any existing or future medium whatsoever, from translating the information into any other language or wording, and from adapting the information.


PFDC cannot be held liable for the consequences, whether direct or indirect, and/or any damage to the Information due to defects or piracy. Additionally, PFDC does not guarantee any result regarding the information or advice provided to Users; the information and advice are simply given under an obligation of means.


Finally, PFDC does not grant any explicit or implied guarantee and does not accept any liability regarding the usage of said information and advice. It is given solely for informational purposes. For any additional information and/or in the case of any doubts, Users can write to the following address: contact.avene@pierre-fabre.com.







ARTICLE 7. INTELLECTUAL PROPERTY


Unless otherwise specified in these conditions, all elements appearing on the Application and the Application itself (including in particular text, data, databases, graphics, logos, trademarks, names, animations, images, videos, sounds, software and all other elements) (hereinafter the “Elements”), are the exclusive property of PFDC and/or third parties who have granted PFDC a license, and fall under French and international copyright law and more broadly under the law on intellectual property.

These Elements are protected by author’s rights, copyrights, trademarks, patents, database rights, trade secrets, and/or all other intellectual property rights.

Any reproduction, representation, or public communication rights are reserved, including visual, photographic, iconographic, or other types of representation. The reproduction of all or part of the Application on any electronic medium whatsoever is strictly prohibited unless specifically authorized by the Director of Publication.

The trademarks and logos used in the Application are registered, their reproduction constitutes an infringement of intellectual property rights. All rights of use are reserved. In accordance with Article L. 122-4 of the French Intellectual Property Code, any representation or reproduction that is not expressly authorized, whether total or partial, and by any means, shall be illegal and shall constitute an infringement punishable under Articles L. 335-2 et seq. of the French Intellectual Property Code.

PFDC grants the User a free, non-exclusive, non-transferable, personal license for private use only to access, use, and view the Application and its Elements. This right is granted exclusively for a personal, private and non-commercial use, and is subject to the retention of all related particulars bearing on reproduction rights and intellectual property rights. In this respect, the User is prohibited from copying and/or reproducing the Elements in full or in part, by any means and on any existing or future medium whatsoever, from translating the Elements into any other language or wording, and from adapting the Elements.

Any other use of the Elements is strictly prohibited and constitutes a violation of the provisions of the French Intellectual Property Code.



ARTICLE 8. HYPERTEXT LINKS


The User is informed that PFDC may provide links to external websites and/or applications that may or may not belong to the Pierre Fabre Group. These websites and/or applications are independent of the Application.

PFDC neither publishes nor monitors the sources and content of these websites and/or applications or their links to other websites and/or applications.

The links to these websites and/or applications do not in any way constitute on the part of PFDC an endorsement, approval, or agreement with the content of these websites and/or applications, especially their potential use.

Consequently, PFDC shall not be held liable for the content, products, services, advertising, cookies, or other elements of these websites and/or applications or any damages or loss, proved or alleged, resulting from or relating to the use of said information, services, or data available on these websites and/or applications.

The creation of hypertext links to the Application may only be done with prior written authorization from PFDC. All requests for authorization should be addressed to the following contact: contact.avene@pierre-fabre.com




ARTICLE 9. GUARANTEES


PFDC guarantees that the content of the Application complies with the provisions of French law in force and the industry standards applicable regarding Internet computer applications.

PFDC guarantees Users the quiet enjoyment of the Application and in particular guarantees that the Application does not violate any intellectual property right held by a third party and that it is original.


PFDC cannot guarantee the exactitude or the completeness of Information on the Application. PFDC will make any necessary appropriate corrections. The Information displayed may also be subject to updates in the interim period between the User first viewing them and the User being fully aware of them. Consequently, PFDC cannot guarantee in any way that the Information is accurate, complete and up to date.


ARTICLE 10. LIABILITY


Use of the Application falls under the sole and entire responsibility of the User. PFDC shall not be held liable for any result obtained following use of the Application. In particular, the User has been informed that the Application is not intended to replace medical advice and does not replace the relationship between the health professional and the patient/User.


Users undertake to not introduce, whether intentionally or unintentionally, any viruses, bugs, or files of any kind whatsoever that disrupt the operation of the Application; In such a case, they alone shall be entirely liable for this action. In the spirit of respect for all, PFDC may sue malicious Users.


The User declares and guarantees that he/she is fully aware of the characteristics and constraints of the Internet, and in particular that the transmission of data and information on the Internet is not fully reliable from a technical standpoint, and that these elements circulate across heterogeneous networks with diverse technical characteristics and capacities, which disrupt access or make access impossible at certain times.


PFDC shall not be held liable for any damage arising following connection to the Application or following use of the Application by a User.


PFDC endeavors to maintain access to the Application 7 days a week and 24 hours a day, but is bound by no obligation to do so. Access may therefore be interrupted, particularly for

maintenance and updating purposes. PFDC reserves the right to modify, suspend or interrupt the publication of all or part of the Application at any time, and without prior notification. Under no circumstances shall PFDC be liable for any such interruptions and the resultant consequences which may arise for the User or any third party.


While PFDC takes the necessary steps to ensure the reliability of the Information and services on the Application, PFDC shall not be held liable for errors, omissions, viruses or other results obtained from the incorrect use of said Information and services. PFDC is in fact only bound by a simple obligation of means.


PFDC, its managers and employees shall not be held liable:

- for any damage whether this arises from connecting to, accessing, or using the Application;

- for damage resulting directly or indirectly from consulting the Application or from the use of the Information available in the Application;

- for direct or indirect damage resulting from use of the Application, in particular any operating, financial or commercial loss or loss of programs or data in any information system, even if PFDC has been informed of the possibility of such damage.

Under no circumstances shall PFDC be held liable for the loss of Information or for any deterioration linked to the Information. No Information or advice provided by the Application shall be interpreted as any form of guarantee.


ARTICLE 11. PERSONAL DATA


Accessing and using the Application results in the collection of personal data (last name, first name, email address), which the User accepts. This personal data shall be kept for the duration necessary for the usage of the Application. Personal data will be processed. For more information about the processing of personal data and your rights, please read the Privacy Policy.


ARTICLE 12. APPLICABLE LAW AND SETTLEMENT OF DISPUTES


The GCU are subject to French law. Any dispute arising in connection with these CGU shall be subject to mediation prior to any legal or arbitral proceeding. Should the mediation fail, the dispute shall be brought before the competent jurisdiction under the Paris Court of Appeals. In the event that the GCU are translated, only the French version is valid and enforceable.


ARTICLE 13. MODIFICATIONS TO THE GCU


Users declare and recognize that they have read the GCU and use of the Application constitutes total and unconditional acceptance of the entire GCU by Users. The GCU are liable to be modified by PFDC at any time. The User shall be notified of these modifications. All use of the Application following notification of a modification shall constitute acceptance of the GCU. The GCU applicable shall then be those in force in the Application at the date of its use by a User. In the event of a disagreement about modifications to the GCU, the User undertakes not to access the Application and to delete it.


Version 4 dated 8/27/2024`


export default text;
